import { Component, EventEmitter, Input, Output } from '@angular/core';

type CardQuantitativoAvaliacaoDesempenho = {
  title: string,
  quantidade: number,
  qtdDescription: string,
  isCardClickable: boolean,
  icon: string,
  colorBorder?: string
};

@Component({
  selector: 'app-cards-quantitativos-avaliacao-desempenho',
  templateUrl: './cards-quantitativos-avaliacao-desempenho.component.html',
  styleUrls: ['./cards-quantitativos-avaliacao-desempenho.component.scss']
})
export class CardsQuantitativosAvaliacaoDesempenhoComponent {
  @Input() cards: CardQuantitativoAvaliacaoDesempenho[];
  @Output() cardClicked = new EventEmitter();

  filterCard(card) {
    if (card.isCardClickable) {
      this.cardClicked.emit(card.title);
    }
  }

  /**
   * Converte cor hex (#RRGGBB ou #RGB) para rgba com alpha
   */
  colorAlpha(hex: string, alpha: number): string {
    if (!hex) return '';
    let c = hex.replace('#', '');
    if (c.length === 3) {
      c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
    }
    const num = parseInt(c, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    return `rgba(${r},${g},${b},${alpha})`;
  }
}
